import React from "react";

import ContractSummaryInfo from "./ContractSummaryInfo";

/**
 * @typedef {import("../../../jsdoc/GroupCount.js").GroupCount} GroupCount
 */

/**
 * Business Breakdown ContractSummary Component
 *
 * @param {Object} props
 * @param {GroupCount[]} props.groupCounts
 * @returns {React.JSX.Element}
 */
export default function ContractSummary({ groupCounts }) {
  return (
    <div className="panel panel-primary table-responsive">
      <div className="panel-heading text-center">
        <strong>Contract Holder/Contracts Summary</strong>
      </div>
      <div className="panel-body">
        <ContractSummaryInfo groupCounts={groupCounts} />
      </div>
    </div>
  );
}
